import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { JwtInterceptor } from './services/jwt.interceptor';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthenticationService } from './services/authentication.service';
import { SharedService } from './shared/shared.service';
import { CommonModule } from '@angular/common';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from './shared/alerts/alerts.service';
import { AlertsComponent } from './shared/alerts/alerts.component';


// Removed incompatible MomentModule
// Removed incompatible Ng2TelInputModule
import { MfaoptionsComponent } from './mfaoptions/mfaoptions.component';
import { TriggermfaComponent } from './triggermfa/triggermfa.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertsandnotificationsComponent } from './alertsandnotifications/alertsandnotifications.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AlertsComponent,
    MfaoptionsComponent,
    TriggermfaComponent,
    AlertsandnotificationsComponent,
    UnauthorizedComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgbModule,
    NgSelectModule,
  ],
  providers: [
    AlertsService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    SharedService,
    AuthenticationService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        //  siteKey: '6LcOuyYTAAAAAHTjFuqhA52fmfJ_j5iFk5PsfXaU',
        siteKey: '6Lcsm9EZAAAAAGfTqzn8Co1E6R33g5la_R1-yKCI',
      } as RecaptchaSettings,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
